import PortfolioSlider from '../components/portfolio-slider.svelte' //portfolio.svelte'
import Portfolio from '../components/portfolio.svelte'
import { fromEvent, throttle, interval } from 'rxjs'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const { $ } = window

export default {
	init() {
		gsap.registerPlugin(ScrollTrigger)
		let $portfolioSliderAnchor = $('#portfolio-slider-wrap')
		if ($portfolioSliderAnchor.length) {
			new PortfolioSlider({
				target: $portfolioSliderAnchor[0],
				props: $portfolioSliderAnchor.data(),
			})
		}

		let $portfolioAnchor = $('#projects-wrap')
		if ($portfolioAnchor.length) {
			new Portfolio({
				target: $portfolioAnchor[0],
				props: null,
			})
		}

		//!popup

		gsap.fromTo(
			'.code-outer:before',
			{ opacity: 0 },
			{ opacity: 1, duration: 3, ease: 'power1.out' }
		)
		gsap.fromTo(
			'.code-inner',
			{ opacity: 0, y: 32 },
			{ opacity: 1, y: 0, duration: 0.35, ease: 'power1.out' }
		)

		let tl = gsap.timeline()
		gsap.set('.hero-content h2', { x: -32 })
		gsap.set('.filter-bar', { x: -16 })
		gsap.set('.hero-img', { opacity: 0 })
		tl.to('.hero-content h2', {
			opacity: 1,
			x: 0,
			ease: 'power1.out',
			duration: 0.65,
		})
		tl.to(
			'.hero-img',
			{ opacity: 1, ease: 'power1.out', duration: 0.65 },
			'-=0.65'
		)
		tl.to(
			'.filter-bar',
			{ opacity: 1, x: 0, y: 0, ease: 'power1.out', duration: 0.65 },
			'-=0.65'
		)
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
